import type { FilterType, SelectItem } from '@core/core/types'

export const vspFilter: SelectItem<FilterType>[] = [
  { label: 'Все', key: 'all' },
  { label: 'Только без сз', key: 'no_vsp' },
  { label: 'Только со сз', key: 'vsp' },
]
